module.exports = __webpack_public_path__ + "img/down-to-line.41a3c9b4.svg";